import React, { useEffect, useRef, useState } from "react";
import {
  formatCountdown,
  getRemainingSeconds,
} from "../../utils/lockoutUtils";

const LockoutCountdown = ({
  lockedUntil,
  retryAfterSeconds,
  onExpire,
  className = "",
  as = "span",
}) => {
  const [remainingSeconds, setRemainingSeconds] = useState(() =>
    getRemainingSeconds(lockedUntil, retryAfterSeconds)
  );
  const hasExpiredRef = useRef(false);
  const hadPositiveTimeRef = useRef(false);

  useEffect(() => {
    hasExpiredRef.current = false;
    hadPositiveTimeRef.current = false;
  }, [lockedUntil, retryAfterSeconds]);

  useEffect(() => {
    const updateRemaining = () => {
      const next = getRemainingSeconds(lockedUntil, retryAfterSeconds);
      setRemainingSeconds(next);
      if (next > 0) {
        hadPositiveTimeRef.current = true;
      }
      if (
        next <= 0 &&
        hadPositiveTimeRef.current &&
        !hasExpiredRef.current
      ) {
        hasExpiredRef.current = true;
        onExpire?.();
      }
      return next;
    };

    updateRemaining();
    const timerId = setInterval(() => {
      const next = updateRemaining();
      if (next <= 0) {
        clearInterval(timerId);
      }
    }, 1000);

    return () => clearInterval(timerId);
  }, [lockedUntil, retryAfterSeconds, onExpire]);

  const Component = as;
  return (
    <Component className={className} aria-live="polite">
      {formatCountdown(remainingSeconds)}
    </Component>
  );
};

export default LockoutCountdown;
